/**
 * @readonly
 * @enum {string}
 */
export const ObjectGroupControlFlags = {
    DELETE_OBJECT_GROUP: 'deleteObjectGroup',
    EDIT_OBJECT_GROUP: 'editObjectGroup',
    EDIT_EVENT_FORWARDING_CONFIG_GROUP: 'editEventForwardingConfigGroup'
}

Object.freeze(ObjectGroupControlFlags)
